export enum AccountType {
    UNSPECIFIED = 'unspecified',
    INCOME = 'income',
    EXPENSE = 'expense',
}
